module.exports = __webpack_public_path__ + "media/images/favicons/icon-196x196-c1d4f45aeea82e3741eb552f7d9d3451.png";